import { ShapeType } from '~/core/enums';
import { ArrowInfo, DrawingEdge, DrawingShape } from '~/core/models';

export const findDrawingEdgeById = (
  id: string,
  shape: DrawingShape
): DrawingEdge | undefined =>
  shape.drawingEdges.find((edge: DrawingEdge) => edge.id === id);

export const findArrowByEdgeId = (
  id: string,
  shape: DrawingShape
): ArrowInfo | undefined =>
  shape.arrowsInfo?.find((arrow: ArrowInfo) => arrow.drawingEdgeId === id);

/**
 * an island is defined as a shape with all sides finished edges
 * @param shape to test
 */
export const isShapeAnIsland = (shape: DrawingShape): boolean => {
  if (shape.type === ShapeType.FAUX_SHAPE) {
    return false;
  }
  // removedElementsHistory.edgesAndCorners is the list of edges which have wall/appliance/waterfall option selected
  const { removedElementsHistory } = shape;

  return !removedElementsHistory?.edgesAndCorners.length;
};
